module.exports = __webpack_public_path__ + "static/media/game.72db9820.jpg";